import { isHttpError } from '@sparkai/utils'

type ErrorBody = { message?: unknown }

const toMessage = (message: unknown): string | undefined => {
  if (typeof message === 'string' && message) return message
  if (Array.isArray(message) && message.length) return message.map(String).join(', ')
  return undefined
}

export function getEligibilityErrorMessage(error: unknown): string | undefined {
  const body = (isHttpError(error) ? error.response?.data : undefined) as ErrorBody | undefined
  return toMessage(body?.message)
}
